<template>
    <div class="row vertical-10p">
        <div class="container">
            <img src="/static/img/logo.png" alt="LeadScorz" title="LeadScorz" class="center-block logo"> 
            <div class="text-center col-md-4 col-sm-offset-4">
                <form class="ui form loginForm" method="POST" v-on:submit.prevent="onSubmit">
                    <div v-show="error" class="alert alert-danger" roler="alert"><strong>Wrong email/password</strong> Please, try again</div>
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fa fa-at"></i></span> 
                        <input v-model="credentials.email" name="email" placeholder="Email" type="email" class="form-control" required>
                    </div> 
                    <div class="input-group">
                        <span class="input-group-addon"><i class="fa fa-lock"></i></span> 
                        <input v-model="credentials.password" name="password" placeholder="Password" type="password" class="form-control" required>
                    </div>    
                    <div class="checkbox">
                        <label><input v-model="rememberMe" type="checkbox"> Remember me</label>
                    </div>
                    <button type="submit" class="btn btn-block btn-primary btn-lg">Login</button>
                </form>
                <div>
                    <router-link to="/reset-password">Forgot your password?</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

 export default {
     data: function () {
         return {
             error: false,
             credentials: {
                 email: null,
                 password: null,
             },
             rememberMe: false,
         };
     },
     created () {
         var self = this;
         console.log('hello');

     },
     methods: {
         login: function () {
             var self = this;

             self.$store.dispatch('login', self.credentials)
                 .then(
                     () => {
                         // A successful login
                         self.$store.dispatch('userReady')
                             .then(() => {
                                 self.$router.push({name: 'panel-home'});
                             });
                     },
                     () => { self.error = true; }
                 );
             
         },
         onSubmit: function () {
             this.login();
         }
     }
 };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body, .container-table {
  height: 100%;
  background-color: #eee;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.form {
  background: #fff;
  padding: 35px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  font-size: 1.1em;
  margin-bottom: 30px;
}

.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.input-group input {
  height: 3em;
  color: #002754 !important;
  font-size: 1.1em;
}

.input-group .input-group-addon {
  border-radius: 0;
  width: 37px;
}
.text-red {
  color: red !important;
}

.btn-primary {
  margin-top: 30px;
  border: 1px solid #ff4d50;
  color: #ff4d50;
  background: #fff;
}

.btn-primary:hover, .btn-primary:focus {
  color: #fff;
  background: #ff4d50;
}
</style>



// WEBPACK FOOTER //
// Login.vue?5b679af2